/** Authenticated CRM shell — all in-app routes live under this prefix. */
export const APP_BASE_PATH = '/app';

/** Build a path under {@link APP_BASE_PATH}. */
export function appPath(subpath = ''): string {
  if (subpath === '' || subpath === '/') {
    return APP_BASE_PATH;
  }
  const suffix = subpath.startsWith('/') ? subpath : `/${subpath}`;
  return `${APP_BASE_PATH}${suffix}`;
}

/** Old top-level app URLs → `/app/...` (hash router, no leading slash on `from`). */
export const LEGACY_APP_ROUTE_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: 'business-overview', to: appPath() },
  { from: 'pulse', to: appPath() },
  { from: 'contacts', to: appPath('/contacts') },
  { from: 'documents', to: appPath('/documents') },
  { from: 'offerings', to: appPath('/offerings') },
  { from: 'offerings/categories', to: appPath('/offerings/categories') },
  { from: 'offerings/segments', to: appPath('/offerings/categories') },
  { from: 'leads', to: appPath('/leads') },
  { from: 'leads/pipeline', to: appPath('/leads/pipeline') },
  { from: 'follow-ups', to: appPath('/tasks') },
  { from: 'campaigns', to: appPath('/campaigns') },
  { from: 'task-dashboard', to: appPath('/task-dashboard') },
  { from: 'tasks', to: appPath('/tasks') },
  { from: 'commissions/calculator', to: appPath('/commissions/calculator') },
  { from: 'commissions/reports', to: appPath('/commissions/reports') },
  { from: 'admin/tasks', to: appPath('/tasks') },
  { from: 'admin/users', to: appPath('/admin/users') },
  { from: 'admin/roles', to: appPath('/admin/roles') },
  { from: 'profile', to: appPath('/profile') },
  { from: 'host', to: appPath('/host') },
  { from: 'unauthorized', to: appPath('/unauthorized') },
  { from: 'settings', to: appPath('/setup') },
  { from: 'setup', to: appPath('/setup') },
];
